import { Link } from "react-router-dom";
import { TypewriterEffectSmooth } from "../ui/typewriter-effect";
import { motion } from "framer-motion";
import { upAndDown } from "../../constants/TextAnimation";
import React from "react";

export const TypewriterEffectSmoothDemo = React.memo(() => {
  const words = [
    {
      text: "Discover",
    },
    {
      text: "How",
    },
    {
      text: "We",
    },
    {
      text: "Empower",
    },
    {
      text: "Business",
      className: "text-gold",
    },
    {
      text: "Success.",
      className: "text-gold",
    },
  ];
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      variants={upAndDown}
      viewport={{ amount: 0.3 }}
      className="flex flex-col items-center justify-center py-10 lg:py-12 bg-black"
    >
      <p className="text-neutral-200 text-base md:text-base lg:text-xl">
        The road to freedom starts from here
      </p>
      <TypewriterEffectSmooth words={words} className="hidden md:flex" />
      <div className="text-2xl text-center leading-none font-bold block md:hidden py-6 px-6">
        Discover How We Empower{" "}
        <span className="text-gold">Business Success.</span>
      </div>
      <div className="flex flex-row md:flex-row space-y-0 md:space-y-0 space-x-4">
        <Link
          to="/about-us"
          onClick={() => window.scrollTo(0, 0)}
          className="px-5 py-2 rounded-lg font-semibold hover:opacity-80 transition duration-200 bg-black border hover:bg-slate-900 border-white border-transparent text-white text-sm"
        >
          Explore
        </Link>
        <Link
          to="/contact"
          onClick={() => window.scrollTo(0, 0)}
          className=" px-5 py-2 rounded-lg font-semibold bg-white text-black border border-black  text-sm hover:opacity-80 transition duration-200 "
        >
          Contact
        </Link>
      </div>
    </motion.div>
  );

});

TypewriterEffectSmoothDemo.displayName = "TypewriterEffectSmoothDemo";
